// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/resources/styles/VideoPicker.css
// module id = 885
// module chunks = 0